import { react } from "uikit";
import { Dispatch } from "react";

// import { PaymentCountryIso } from "../../../../../../../../services/PaymentSystem";

import MaibPaymentsCountryIso from ".";

interface Context {
	value: MaibPaymentsCountryIso.Value;
	setError: Dispatch<boolean>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		// const isValid =
		// 	this.context?.value.maibPaymentsCountryIso !==
		// 	PaymentCountryIso.NULL;

		// if (!isValid) {
		// 	this.context?.setError(true);
		// 	return isValid;
		// }
		// this.context?.setError(false);
		// return isValid;

		this.context?.setError(false);

		return true;
	}
}
